import type { NextPage } from 'next';
import { Page as Component } from '~/containers/specifics/vendors/settings//profiles/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/settings/profiles';

const ProfileSetting: NextPage = () => (
  <>
    <NskHead title="プロフィール設定" />
    <Component />
  </>
);

export default ProfileSetting;
